import styled from "@emotion/styled";
import { Box } from "@mui/material";
import AlertIcon from "../../../../constants/icons/AlertIcon";
import { COLOR_MAP } from "../../../../constants/ColorNames";


const ForbiddenStripWrapper = styled(Box)`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  padding: 0.4rem 1.6rem;
  background-color: ${COLOR_MAP.FAILURE_BACKGROUND};
  border-width: 0.1rem 0;
  border-style: solid;
  border-color: ${COLOR_MAP.FAILURE_BORDER};
` 

const ForbiddenText = styled.p`
  margin: 0;
  font-size: 1.4rem;
  font-weight: 400;
  line-height: 2rem;
  color: ${COLOR_MAP.FAILURE}
`

const ForbiddenWordsStrip = () => {
  return (
    <ForbiddenStripWrapper>
      <AlertIcon height="24" width="24"/>
      <ForbiddenText>
        You have used the forbidden words, kindly change them.
      </ForbiddenText>
    </ForbiddenStripWrapper>
  )
}

export  default ForbiddenWordsStrip;
